<template>
    <modal :modal-id="modalId" :class="modalBodyClass" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader" />

            <div class="modal-sidebar">
                <div class="modal-contentbox-tabs tab-start" :class="this.inputs.timeline_state > 5 ? '' : 'tab-indent'">
                    <button v-if="this.tableId == 'quiz'" class="tab" :class="this.currentTab == 'main' ? 'active' : ''" @click.prevent="showTab('main')">
                        <app-icon :name="'file-text'" width="25" height="25" />
                        <span>{{ $t("test_quiz") }}</span>
                    </button>
                    <button v-if="this.tableId == 'feedback'" class="tab" :class="this.currentTab == 'main' ? 'active' : ''" @click.prevent="showTab('main')">
                        <app-icon :name="'message-circle'" width="25" height="25" />
                        <span>{{ $t("feedback") }}</span>
                    </button>
                    <button v-if="this.tableId == 'message'" class="tab" :class="this.currentTab == 'main' ? 'active' : ''" @click.prevent="showTab('main')">
                        <app-icon :name="'mail'" width="25" height="25" />
                        <span>{{ $t("SMS") }}</span>
                    </button>
                    <button v-if="this.tableId == 'document'" class="tab" :class="this.currentTab == 'main' ? 'active' : ''" @click.prevent="showTab('main')">
                        <app-icon :name="'file-text'" width="25" height="25" />
                        <span>{{ $t("document") }}</span>
                    </button>

                    <button v-if="this.inputs.category != 'message'" class="tab" :class="this.currentTab == 'form' ? 'active' : ''" @click.prevent="showTab('form')">
                        <app-icon :name="'edit'" width="25" height="25" />
                        <span v-if="this.inputs.category == 'document'">{{ $t("request_fill") }}</span>
                        <span v-else-if="this.inputs.category == 'quiz'">{{ $t("request_fill_quiz") }}</span>
                        <span v-else-if="this.inputs.category == 'feedback'">{{ $t("request_fill_feedback") }}</span>
                    </button>
                    <button class="tab" :class="this.currentTab == 'attendees' ? 'active' : ''" @click.prevent="showTab('attendees')">
                        <app-icon :name="'user'" width="25" height="25" />
                        <span>{{ $t("course_atendees") }}</span>
                    </button>

                    <button v-if="this.inputs.category != 'message'" class="tab" :class="this.currentTab == 'results' ? 'active' : ''" @click.prevent="showTab('results')">
                        <app-icon :name="'bar-chart'" width="25" height="25" />
                        <span>{{ $t("results") }}</span>
                    </button>
                    <button v-else class="tab" :class="this.currentTab == 'history' ? 'active' : ''" @click.prevent="showTab('history')">
                        <app-icon :name="'bar-chart'" width="25" height="25" />
                        <span>{{ $t("results") }}</span>
                    </button>
                </div>

                <div v-if="selectedUrl" class="mobile-action-footer">
                    <div class="d-none d-md-block">
                        <a href="" class="action-option" @click.prevent="closeModalAndOpen('rejection')">
                            <div class="btn btn-secondary btn-sm btn-circle btn-circle-xs">
                                <app-icon :name="'trash'" width="18" height="18" />
                            </div>
                            <span class="red">{{ $t("delete") }}</span>
                        </a>
                    </div>
                </div>
            </div>

            <form id="modal-contentbox-start" class="col-md-9 pl-2 pt-0 pr-0 mb-1 modal-contentbox-body" :class="{ 'loading-opacity': preloader }" ref="form" :data-url="selectedUrl ? `admin/app/forms/${inputs.id}` : `admin/app/forms`">
                <div v-show="this.currentTab == 'main'" class="modal-contentbox-row pr-0">
                    <div class="form-group row align-items-center pl-0 pr-0 mb-30 col-md-12">
                        <div class="row col-sm-12 p-0">
                            <div class="col-sm-4">
                                <label for="inputs_name" class="col-sm-12">
                                    {{ $t("form_name") }}
                                </label>
                                <app-input id="inputs_name" class="col-sm-12 pr-0 mb-4" type="text" v-model="inputs.name" :placeholder="$t('text_type_input')" :required="true" />
                            </div>
                            <div class="col-sm-4">
                                <label for="inputs_label" class="col-sm-12">
                                    {{ $t("one_tag") }}
                                </label>
                                <app-input id="inputs_label" class="col-sm-12 pr-0 mb-4" type="text" v-model="inputs.label" :placeholder="$t('text_type_input')" />
                            </div>
                        </div>
                        <div v-if="this.inputs.category == 'document'" class="row col-sm-12 p-0">
                            <div class="col-sm-8">
                                <label for="inputs_name" class="col-sm-12">
                                    {{ $t("action") }}
                                </label>
                                <app-input id="inputs_document_type" type="select" class="col-sm-12 pr-0 mb-4" :title="$t('action')" v-model="inputs.document_type" :list="documentTypeLists" />
                            </div>
                        </div>
                        <div v-if="this.inputs.category != 'message' && this.inputs.document_type == 'sign_uploaded_document'" class="col-12">
                            <app-form-attachment :table-id="''" :form-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : temporaryId" class="loading-hidden"></app-form-attachment>
                            <app-attachment-upload-form :table-id="''" :form-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : temporaryId"></app-attachment-upload-form>
                            <div class="note note-silver row ml-0 mt-3 w-100">
                                <div class="col-sm-12 col-md-9 mt-0 mb-3">
                                    {{ $t("sign_uploaded_document_note") }}
                                </div>
                            </div>
                        </div>
                        <div v-if="this.inputs.category != 'message' && this.inputs.document_type != 'sign_uploaded_document' && this.inputs.document_type != 'fill'" class="row col-sm-12 p-0 pl-3">
                            <label for="inputs_document_content" class="col-sm-12 col-md-6">
                                <span v-if="this.inputs.category == 'document'">{{ $t("content_of_document") }}</span>
                                <span v-else-if="this.inputs.category == 'feedback'">{{ $t("content_of_feedback") }}</span>
                                <span v-else-if="this.inputs.category == 'quiz'">{{ $t("content_of_document") }}</span>
                            </label>
                        </div>
                        <div v-if="this.inputs.category != 'message' && this.inputs.document_type != 'sign_uploaded_document' && this.inputs.document_type != 'fill'" class="col-12">
                            <app-input type="text-editor" v-model="inputs.document_content" v-if="!preloader" :text-editor-hints="textEditorHints(Object.keys(variables))" row="5" id="text-editor-for-template" />

                            <div v-if="this.inputs.category == 'document' && !this.showVariables && this.inputs.document_type != 'fill'" class="note note-silver row ml-0 mt-3">
                                <div class="col-sm-12 col-md-9 mt-0">
                                    {{ $t("generate_document_note") }}
                                </div>
                                <div class="col-sm-12 col-md-3 mt-0">
                                    <button class="btn btn-primary" @click.prevent="showFormVariables()">
                                        {{ $t("add_variable") }}
                                    </button>
                                </div>
                            </div>
                            <div v-if="this.inputs.category == 'document' && this.showVariables" class="form-group pt-2">
                                <button type="button" class="btn btn-sm btn-primary px-3 py-1 margin-left-2 mt-2" data-toggle="tooltip" data-placement="top" v-for="variable in allVariables" :title="variable.description" @click="addTag(variable.variable)">{{ variable.variable }}</button>
                            </div>
                        </div>
                        <div v-if="this.inputs.category == 'document' && this.inputs.document_type == 'fill'" class="note note-silver row ml-0 mt-3">
                            <div class="col-sm-12 col-md-12 mt-0">
                                {{ $t("no_document_to_sign") }}
                            </div>
                        </div>

                        <div v-if="this.inputs.category == 'message'" class="col-sm-12 mt-1 mb-4 p-0">
                            <label for="inputs_note" class="col-sm-12 mb-0"> {{ $t("message") }} </label>
                            <app-input id="inputs_note" class="col-sm-12" :class="'note_added'" type="textarea" v-model="inputs.note" :placeholder="$t('text_type_input')" />
                        </div>

                    </div>
                </div>

                <div v-show="this.currentTab == 'form'" class="modal-contentbox-row pr-0">
                    <div class="form-group row align-items-center pl-0 pr-0 mb-30 col-md-12">
                        <app-form-items v-if="finishedGetData && this.inputs.category != 'message'" :form-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : temporaryId" :form-category="inputs.category" :initial-rows="inputs.form_fields_with_files.length !== 0 ? inputs.form_fields_with_files : []" @getFormData="getFormsData"> </app-form-items>
                    </div>
                </div>

                <div v-show="this.currentTab == 'attendees'" class="modal-contentbox-row pr-0">
                    <div class="form-group row align-items-center pl-0 pr-0 mb-30 col-md-12">
                        <label v-if="this.inputs.category != 'message'" for="inputs_timeline_state_form" class="col-sm-12 mt-0"> {{ $t("timeline_course_date") }} <app-icon :name="'clock'" width="20" height="20" class="mt-0" /> </label>
                        <app-input v-if="this.inputs.category != 'message'" id="inputs_timeline_state_form" class="large-input col-sm-12 pr-0 mb-3" type="select" :title="$t('timeline_state')" v-model="inputs.timeline_state" :list="timelineStatesLists" :required="true" />

                        <div v-if="inputs.timeline_state >= 13 && this.inputs.category != 'message'" class="col-12 row mb-4">
                            <app-input id="inputs_deadline_month_form" class="col-sm-4 pr-0" type="number" :minNumber="0" v-model="inputs.deadline_month" />
                            <label for="inputs_deadline_month_form" class="col-sm-8 mt-0 pt-md-2 mb-4">
                                {{ $t("deadline_month") }}
                            </label>
                        </div>
                        <hr v-if="this.inputs.category != 'message'" />

                        <label for="inputs_status" class="col-sm-12">
                            {{ $t("course_atendees") }}
                        </label>

                        <div v-if="this.atendeeOptions.length !== 0" class="note note-info row ml-2 p-4 col-sm-12">
                            <div class="col-md-1">
                                <app-icon :name="'users'" width="30" height="30" />
                            </div>
                            <div class="col-md-11">
                                <b
                                    >{{ $t("no_of_users_that_will_attend") }} {{ atendeeOptions.total }}
                                    <span v-if="atendeeOptions.total < 5">{{ $t("people_plural_3rd") }}</span>
                                    <span v-else-if="atendeeOptions.total > 5">{{ $t("people_plural_2nd") }}</span>
                                    {{ this.percentOfCompanyThatAttends }}<br />
                                    {{ $t("all_who_match_at_least_one_condition") }}
                                </b>
                            </div>
                        </div>

                        <label for="inputs_candidate_id" class="col-sm-12 mt-3">
                            {{ $t("course_atendees_person") }}
                        </label>
                        <app-input id="inputs_candidate_id" class="col-sm-12" type="multi-select" :list="candidateOptions" :isAnimatedDropdown="true" v-model="inputs.candidate_id" @input="getAttendees" />

                        <label for="inputs_job_id" class="col-sm-12 mt-4">
                            {{ $t("course_atendees_jobs") }}
                        </label>
                        <app-input id="inputs_job_id" class="col-sm-12" type="multi-select" :list="jobOptions" :isAnimatedDropdown="true" v-model="inputs.job_id" @input="getAttendees" />

                        <label for="inputs_tag_id" class="col-sm-12 mt-4">
                            {{ $t("course_atendees_tags") }}
                        </label>
                        <div class="col-sm-12">
                            <app-tag-manager :tags="tags" v-model="inputs.tag_id" :list="tagOptions" list-value-field="value" @attachTag="attachTag" @detachTag="detachTag" />
                        </div>

                        <div v-if="this.inputs.category == 'message'" class="mt-4">
                            <label class="col-sm-12 mt-0"
                                >Rozeslání zprávy účastníkům <span v-if="this.atendeeOptions.data">({{ this.atendeeOptions.to }})</span></label
                            >
                            <app-employee-list :employees="this.atendeeOptions ? this.atendeeOptions : ''" class="col-sm-12 loading-hidden"></app-employee-list>
                            <div class="col-sm-12">
                                <button class="btn btn-primary btn-with-icon" @click.prevent="sentMessage()"><i class="custom-icon-set custom-icon-set-notify-user mr-3"></i> &nbsp;&nbsp;Odeslat</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="this.inputs.status !== 4 && this.inputs.category != 'message'" class="form-group row align-items-center mt-5 pl-0 pr-0 mb-30 col-md-12">
                        <label for="inputs_status" class="col-sm-12"> {{ $t("active_courses") }} </label>
                        <app-input id="inputs_status" class="col-sm-4" type="select" v-model="inputs.status" :list="statusLists" />
                    </div>
                </div>
                <div v-if="this.inputs.category != 'message'" v-show="this.currentTab == 'results'" class="modal-contentbox-row pr-0 w-100 pb-5">
                    <div v-if="this.atendeeOptions && this.graduateOptionsUnique">
                        <div v-if="this.selectedUrl" class="col-12 col-md-6 p-0 float-left form-group row align-items-center mb-2">
                            <label for="inputs_finished" class="col-sm-12">
                                {{ $t("already_graduated") }}
                                <div v-if="graduateOptionsUnique.data" class="btn btn-primary btn-sm badge-counter">{{ graduateOptionsUnique.data.length }}</div>
                            </label>
                            <div class="mb-0 col-sm-12 mb-5">
                                <app-employee-list :employees="this.graduateOptionsUnique ? this.graduateOptionsUnique : ''" class="loading-hidden"></app-employee-list>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 p-0 float-left form-group row align-items-center mb-2">
                            <label for="inputs_finished" class="col-sm-12">
                                {{ $t("future_atendees") }}
                                <div v-if="atendeeOptions.data" class="btn btn-primary btn-sm badge-counter">{{ atendeeOptions.data.length }}</div>
                            </label>
                            <div class="mb-0 col-sm-12 mb-5">
                                <app-employee-list :employees="this.atendeeOptions ? this.atendeeOptions : ''" class="loading-hidden"></app-employee-list>
                            </div>
                        </div>
                    </div>

                    <div v-if="graduateOptions.total" class="">
                        <div class="col-12 col-md-6 p-4 float-left form-group row align-items-center mb-0">
                            <app-chart v-if="isActiveAtendeeStats && isActiveAtendeeStatsAndDisplayed" class="mb-primary mt-4" type="dough-chart" :width="320" :height="160" :labels="graduateStats.labels" :data-sets="graduateStats.dataSet" />
                        </div>
                        <div class="col-12 col-md-6 pt-5 pl-1 float-left form-group row align-items-center mb-0">
                            <div class="chart-data-list">
                                <div class="row">
                                    <label for="inputs_finished" class="col-sm-12 mb-3">
                                        {{ $t("graduates_answers") }}
                                    </label>
                                    <div class="col-12" v-for="(item, index) in graduateStats.chartElement" :key="index">
                                        <div class="data-group-item" :style="item.color">
                                            <span class="square" :style="item.background_color" />
                                            {{ item.key }}
                                            <span class="value">{{ item.value }}</span>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-4 pl-0">
                                        <label v-if="graduateOptions.totalInLast30Days.change.includes('-') && graduateOptions.totalInLast30Days.total > 0 && graduateOptions.totalBefore30Days.total > 0" for="" class="col-sm-12">
                                            {{ $t("in_the_last_30_days") }} <span style="color:rgb(188, 51, 93)">{{ $t("in_the_last_30_days_about") }} {{ graduateOptions.totalInLast30Days.change.replace("-", "") }} {{ $t("worst_answers_in_comparsion") }} &#9660; </span>
                                        </label>
                                        <label v-else-if="graduateOptions.totalInLast30Days.total > 0 && graduateOptions.totalBefore30Days.total > 0" for="" class="col-sm-12">
                                            {{ $t("in_the_last_30_days") }} <span style="color:rgb(86, 129, 139)">{{ $t("in_the_last_30_days_about") }} {{ graduateOptions.totalInLast30Days.change }} {{ $t("better_answers_in_comparsion") }} &#9650; </span>
                                        </label>
                                        <label v-else-if="graduateOptions.totalInLast30Days.total == 0 && graduateOptions.totalBefore30Days.total > 0" for="" class="col-sm-12"> {{ $t("in_the_last_30_days") }} {{ $t("in_the_last_30_days_no_answers") }} </label>
                                        <label v-else-if="graduateOptions.totalInLast30Days.total > 0 && graduateOptions.totalBefore30Days.total == 0" for="" class="col-sm-12">
                                            {{ $t("in_the_last_30_days_first_answers") }}
                                        </label>
                                        <label v-else-if="graduateOptions.totalInLast30Days.total == 0 && graduateOptions.totalBefore30Days.total == 0 && graduateOptions.totalText == 0" for="" class="col-sm-12">
                                            {{ $t("no_answers_yet") }}
                                        </label>
                                        <br />
                                        <div v-if="(graduateOptions.totalInLast30Days.total != 0 || graduateOptions.totalBefore30Days.total != 0) && graduateOptions.totalText == 0" class="col-sm-12 text-muted small">{{ $t("current_success") }} {{ graduateOptions.totalInLast30Days.correctRatio }} ({{ graduateOptions.totalInLast30Days.total }} {{ $t("answers_plural") }})<br />{{ $t("success_30_days_ago") }} {{ graduateOptions.totalBefore30Days.correctRatio }} ({{ graduateOptions.totalBefore30Days.total }} {{ $t("answers_plural") }})</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 p-4 float-left form-group row align-items-center mb-0 card card-outline d-block text-muted">
                            <div class="col-12 col-md-6 text-center">
                                <app-icon :name="'clock'" width="25" height="25" class="mr-2" />
                                <b>{{ this.graduateOptions.totalDeadlines.ontimeRatio }}</b>
                                {{ $t("answers_form_ontime") }}
                            </div>
                            <div class="col-12 col-md-6 text-center">
                                <span v-if="this.graduateOptions.totalDeadlines.average == 1">
                                    <app-icon :name="'check'" width="25" height="25" class="mr-2" />
                                    <b>{{ this.graduateOptions.totalDeadlines.average }}</b> {{ $t("day_before_deadline") }} {{ $t("average_delay") }}
                                </span>
                                <span v-else-if="this.graduateOptions.totalDeadlines.average >= 0 && this.graduateOptions.totalDeadlines.average < 5">
                                    <app-icon :name="'check'" width="25" height="25" class="mr-2" />
                                    <b>{{ this.graduateOptions.totalDeadlines.average }}</b> {{ $t("days_before_deadline") }} {{ $t("average_delay") }}
                                </span>
                                <span v-else-if="this.graduateOptions.totalDeadlines.average >= 0">
                                    <app-icon :name="'check'" width="25" height="25" class="mr-2" />
                                    <b>{{ this.graduateOptions.totalDeadlines.average }}</b> {{ $t("days_plural_before_deadline") }} {{ $t("average_delay") }}
                                </span>
                                <span v-else>
                                    <app-icon :name="'x'" width="25" height="25" class="mr-2" />
                                    <b>{{ this.graduateOptions.totalDeadlines.average * -1 }}</b> {{ $t("day_after_deadline") }} {{ $t("average_delay") }}
                                </span>
                            </div>
                        </div>

                        <hr />
                        <div class="col-12 col-md-12 p-0 float-left form-group row align-items-center mb-0">
                            <div class="col-12 pr-0">
                                <app-result-list :results="this.graduateOptions.data ? this.graduateOptions.data : ''" class="loading-hidden"></app-result-list>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center mt-5">
                        Zde se objeví výsledky hned jak nasbíráte nějaké odpovědi
                    </div>
                    <div v-if="this.inputs.category != 'message'" class="form-group row align-items-center mb-2">
                        <hr />
                        <label for="inputs_note" class="col-sm-12 mb-0"> {{ $t("form_note") }} {{ $t("(internal)") }} </label>
                        <app-input id="inputs_note" class="col-sm-12" :class="inputs.note ? 'note_added' : ''" type="textarea" v-model="inputs.note" :placeholder="$t('text_type_input')" />
                    </div>
                </div>

                <div v-if="this.inputs.category == 'message'" v-show="this.currentTab == 'history'" class="modal-contentbox-row pr-0 w-100 pb-5">
                    <div v-if="messageOptions.total" class="">
                        <div v-for="(item, index) in messageOptions.data">
                            <div class="row mb-2 form-result-answer">
                                <div class="col-sm-12 col-md-5 pl-4">
                                    {{ item.text }}
                                </div>
                                <div class="col-sm-12 col-md-2 p-0">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user text-muted mr-2">
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                            <circle cx="12" cy="7" r="4"></circle>
                                        </svg>
                                        <a :href="'/onboarding?profile=' + item.candidate.id" target="_blank"> {{ item.candidate.name }} {{ item.candidate.surname }}</a>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4 text-right">
                                    {{ formatDate(item.created_at) }}
                                </div>
                            </div>
                            <hr />
                        </div>
                    </div>
                    <div v-else class="text-center mt-5">
                        Zde se objeví výsledky hned jak nasbíráte nějaké odpovědi
                    </div>
                </div>

                <br />
            </form>
        </template>
    </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import { textEditorHints } from "../../../../../Helpers/Helpers";

export default {
    name: "AddModal",
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: String,
    },
    watch: {
        tags(val, oldVal) {
            if (this.finishedGetTag) {
                this.getAttendees();
            }
        },
    },
    computed: {
        allVariables() {
            const variables = Object.keys(this.variables).filter((variable) => {
                return ["{firstname}", "{surname}", "{job_name}", "{email}", "{phone}", "{gender}", "{birthdate}", "{birthplace}", "{linkedin}", "{street}", "{house_no}", "{postal_code}", "{city}", "{banking_account}", "{personal_identification_number}", "{insurance}", "{signature_place}", "{signature_date}"].includes(variable);
            });
            return variables.map((variable) => {
                return { variable, description: this.variables[variable] };
            });
        },
        percentOfCompanyThatAttends() {
            let percent = Math.round(100 * (this.atendeeOptions.total / this.candidateOptions.length) * 10) / 10;
            if(percent > 100){
                return "";
            } else {
                return "("+percent+this.$t("percent_of_company_that_will_attend")+")";
            }
            
        }
    },
    data() {
        return {
            preloader: false,
            editorPreloader: false,
            finishedGetData: false,
            finishedGetJob: false,
            finishedGetCandidate: false,
            finishedGetTag: false,
            showDocumentUpload: false,
            showVariables: false,

            variables: {
                "{firstname}": "Jméno",
                "{surname}": "Příjmení",
                "{job_name}": "Název pozice",
                "{email}": "E-mail",
                "{phone}": "Telefon",
                "{gender}": "Pohlaví",
                "{birthdate}": "Datum narození",
                "{birthplace}": "Místo narození",
                "{linkedin}": "LinkedIn profil",
                "{street}": "Ulice",
                "{house_no}": "Číslo domu",
                "{postal_code}": "PSČ",
                "{city}": "Město",
                "{banking_account}": "Číslo účtu",
                "{personal_identification_number}": "Osobní personální číslo",
                "{insurance}": "Číslo pojištovny",
                
            },
            textEditorHints,

            inputs: {
                name: "",
                attachment: "",
                label: "",
                category: "",
                job_id: [],
                candidate_id: [],
                tag_id: [],
                status: 1,
                timeline_state: 7,
                deadline_month: "",
                document_type: "fill_and_sign",

                answer_1: 0,
                answer_2: 0,
                answer_3: 0,

                fields: [],
                form_fields_with_files: [],
            },

            selectedAction: "body1",
            selectedId: "100",
            currentTab: "main",

            job: 1,
            isNotePreselectionHidden: true,
            isNoteStatusHidden: true,
            fields: [],
            jobOptions: [],
            candidateOptions: [],
            atendeeOptions: {
                total: 0,
            },
            graduateOptions: {
                data: [],
                total: 0,
            },
            graduateOptionsUnique: {
                data: [],
                total: 0,
            },
            messageOptions: {
                data: [],
                total: 0,
            },
            tags: [],
            tagOptions: [],
            statusLists: [
                { id: 1, value: "Ano" },
                { id: 2, value: "Ne, dočasně vypnout" },
            ],
            answerLists: [
                { id: "0", value: "Ano" },
                { id: "1", value: "Ne" },
            ],
            timelineStatesLists: [
                {id: '7', value: 'Před nástupem'},
                {id: '8', value: 'První den'},
                {id: '9', value: 'Zkušební doba'},
                {id: '10', value: 'Zaměstnání'},
                {id: '11', value: 'Povýšení'},
                {id: '12', value: 'Mateřská'},
                {id: '13', value: 'Offboarding'},
            ],
            documentTypeLists: [
                { id: "fill_and_sign", value: this.$t("fill_form_and_sign_generated_document") },
                { id: "sign_uploaded_document", value: this.$t("sign_uploaded_document") },
                { id: "fill", value: this.$t("fill_form") },
            ],

            formFinishedBy: "",
            graduateStats: {},
            isActiveAtendeeStats: false,
            isActiveAtendeeStatsAndDisplayed: false,

            list: [
                {
                    id: "Beginner",
                    value: "Beginner",
                },
                {
                    id: "Intermediate",
                    value: "Intermediate",
                },
                {
                    id: "Professional",
                    value: "Professional",
                },
                {
                    id: "Master",
                    value: "Master",
                },
            ],

            modalId: "add-edit-Modal",
            modalBodyClass: "add-edit-modal",
            modalTitle: this.$t("add"),
            temporaryId: "0",
        };
    },

    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t("edit");
            this.formFinishedBy = "Erik Dvořák";
            this.preloader = true;
        } else {
            this.finishedGetData = true;
        }

        if (this.selectedUrl === "") {
            this.temporaryId = Math.floor(Math.random() * 10000 + 900000).toString();
        }
    },
    mounted() {
        this.getTableId();
        this.getJobs();
        this.getCandidates();
        this.getTags();
    },
    methods: {
        /**
         * Display
         * */

        showTab(tab) {
            this.currentTab = tab;
            document.getElementById("modal-contentbox-start").scrollIntoView();

            if (tab == "results") {
                let _this = this;

                setTimeout(function() {
                    _this.isActiveAtendeeStatsAndDisplayed = true;
                }, 300);
            }
        },

        /**
         * Modals
         * */

        closeModalAndOpen(modal) {
            this.inputs.status = 3;
            this.submit();
        },

        /**
         * Actions
         * */

        documentUpload(toggle) {
            this.showDocumentUpload = toggle;
        },

        addTag(tag_name = '{name}') {
            $("#text-editor-for-template").summernote('editor.saveRange');
            $("#text-editor-for-template").summernote('editor.restoreRange');
            $("#text-editor-for-template").summernote('editor.focus');
            if (tag_name == '{app_logo}') $("#text-editor-for-template").summernote('pasteHTML',
                '<img src="{app_logo}" style="height: 75px"/>');
            else $("#text-editor-for-template").summernote('editor.insertText', tag_name);
        },

        attachTag(tagId) {
            if (isNaN(tagId)) {
                // console.log(tagId+' is not a number');
            } else {
                this.tags.push(tagId);
            }
        },

        detachTag(tagId) {
            let index = this.tags.indexOf(tagId);
            this.tags.splice(index, 1);
        },

        formatDate(date) {
            let formattedDate = " – " + this.$t("no_date");
            if (date) {
                formattedDate = moment(date).format("DD. MM. HH:mm");
                this.hasEventDate = true;
            }
            return formattedDate;
        },

        showFormVariables() {
            this.showVariables = true;
        },

        /**
         * Get additional data
         * */

        getJobs() {
            // Display available jobs
            this.axiosGet("admin/app/jobs")
                .then((response) => {
                    const jobOptionsArray = response.data.map(({ job: value, ...rest }) => ({
                        value,
                        ...rest,
                    }));

                    this.jobOptions = jobOptionsArray;
                })
                .catch(({ response }) => {})
                .finally(() => {
                    this.finishedGetJob = true;
                });
        },

        getCandidates() {
            // Display available candidates
            this.axiosGet("admin/app/candidates?filter_with_status=3&per_page=5000")
                .then((response) => {
                    const candidateOptionsArray = response.data.data.map(({ fullname: value, ...rest }) => ({
                        value,
                        ...rest,
                    }));
                    this.candidateOptions = candidateOptionsArray;
                })
                .catch(({ response }) => {})
                .finally(() => {
                    this.finishedGetCandidate = true;
                });
        },

        getAttendees() {
            // Display atendees of course/quiz/feedback
            if (this.finishedGetData) {
                let selectedAtendees = {
                    status: 3,
                    job: JSON.stringify(this.inputs.job_id),
                    id: JSON.stringify(this.inputs.candidate_id),
                    tag: this.finishedGetTag ? JSON.stringify(this.tags) : this.inputs.tag_id,
                    per_page: 5000,
                };

                this.axiosGet("admin/app/attendees", {
                    params: selectedAtendees,
                })
                    .then((response) => {
                        this.atendeeOptions = response.data;
                        this.getGraduates();

                        if(this.inputs.category == "message"){
                            this.getMessages();
                        }
                        
                    })
                    .catch(({ response }) => {})
                    .finally(() => {});
            }
        },

        getGraduates() {
            // Display stats of finished vs unfinished forms by candidates
            let url = "admin/app/form-graduates",
                reqData = {};

            reqData.params = {
                id: this.inputs.id,
            };

            this.axiosGet(url, reqData)
                .then((response) => {
                    this.graduateOptions = response.data;

                    let attendees = this.atendeeOptions.data;
                    let graduateIds = response.data.graduateIds;

                    this.atendeeOptions.data = attendees.filter(function(attendee) {
                        return !graduateIds.includes(attendee.id); // data.id != response.data[0].id && data.id !== response.data[1].id;
                    });

                    this.graduateOptionsUnique.data = response.data.graduates;
                    this.graduateOptionsUnique.total = response.data.totalGraduates;
                })
                .catch(({ response }) => {})
                .finally(() => {
                    this.isActiveAtendeeStats = true;
                    this.getGraduateStats();
                });
        },

        getGraduateStats() {
            let totalCorrect = 0;
            let totalWrong = 0;
            let totalText = 0;
            if (this.graduateOptions.totalCorrectAnswers) {
                totalCorrect = this.graduateOptions.totalCorrectAnswers;
            }
            if (this.graduateOptions.totalWrongAnswers) {
                totalWrong = this.graduateOptions.totalWrongAnswers;
            }
            if (this.graduateOptions.totalText) {
                totalText = this.graduateOptions.totalText;
            }

            this.graduateStats = {
                labels: [this.$t("wrong"), this.$t("correct"), this.$t("form_type_text")],
                dataSet: [
                    {
                        borderWidth: 0,
                        backgroundColor: ["#bc335d", "#56818B", "#ffc571"],
                        data: [totalWrong, totalCorrect, totalText],
                    },
                ],
                chartElement: [
                    {
                        key: this.$t("wrong"),
                        value: totalWrong,
                        background_color: "background-color: #bc335d;",
                        color: "color: #bc335d;",
                    },
                    {
                        key: this.$t("correct"),
                        value: totalCorrect,
                        background_color: "background-color: #56818B;",
                        color: "color: #56818B;",
                    },
                    {
                        key: this.$t("form_type_text"),
                        value: totalText,
                        background_color: "background-color: #ffc571;",
                        color: "color: #ffc571;",
                    },
                ],
            };
        },

        getMessages() {
            // Get history of all SMS messages sent via this form
            let url = "admin/app/candidates-messages",
                reqData = {};

            reqData.params = {
                sortBy: "id",
                orderBy: "asc",
                form: this.inputs.id,
            };

            this.axiosGet(url, reqData)
                .then((response) => {
                    this.messageOptions = response.data;

                    //this.messageOptions.data = response.data;
                    //this.messageOptions.total = response.total;
                })
                .catch(({ response }) => {})
                .finally(() => {});
        },

        getTags() {
            // Display available tags
            this.axiosGet("admin/app/tags")
                .then((response) => {
                    const tagOptionsArray = response.data.data.map(({ name: value, ...rest }) => ({
                        value,
                        ...rest,
                    }));

                    this.tagOptions = tagOptionsArray;
                })
                .catch(({ response }) => {})
                .finally(() => {
                    this.finishedGetTag = true;
                });
        },

        getFormsData(data) {
            // Prepare questions & answers data for submit of whole form
            this.fields = JSON.parse(data);
        },

        getTableId() {
            // Get table origin id
            if (this.tableId == "quiz") {
                this.inputs.category = "quiz";
            } else if (this.tableId == "feedback") {
                this.inputs.category = "feedback";
            } else if (this.tableId == "course-quiz") {
                this.inputs.category = "course-quiz";
            } else if (this.tableId == "message") {
                this.inputs.category = "message";
            } else if (this.tableId == "document") {
                this.inputs.category = "document";
            }
        },

        getLastFormId() {
            // Get last form Id on submit and replace temporary one used for upload
            // @todo: use only if neccessary – only for uploads before form is created
            if (this.selectedUrl === "") {
                this.axiosGet("admin/app/last-form")
                    .then((response) => {
                        if (response.data) {
                            this.afterGetLastForm(response.data);
                        }
                    })
                    .finally(() => {});
            }
        },

        afterGetLastForm(form) {
            // Get last form Id on submit and replace temporary one used for upload
            // @todo: use only if neccessary – only for uploads before form is created
            if (this.temporaryId != "0") {
                this.axiosPost({
                    url: "admin/app/resolve-temporary-form",
                    data: { temp: parseInt(this.temporaryId), last: form.id },
                })
                    .then((response) => {})
                    .finally(() => {});
            }
        },

        /**
         * Save basic data
         */

        submit() {
            this.inputs.tag_id = this.tags;
            this.inputs.form_fields_with_files = this.fields;

            if (!this.selectedUrl) {
                // Fix to prevent double "" preventing from loading after save                
                if(Array.isArray(this.inputs.tag_id)){
                    this.inputs.tag_id = JSON.stringify(this.tags);
                } else {
                    console.log("tag_id is not array");
                }
                if(Array.isArray(this.inputs.job_id)){
                    this.inputs.job_id = JSON.stringify(this.inputs.job_id);
                } else {
                    console.log("job_id is not array");
                }
                if(Array.isArray(this.inputs.candidate_id)){
                    this.inputs.candidate_id = JSON.stringify(this.inputs.candidate_id);
                } else {
                    console.log("candidate_id is not array");
                }
            } 

            // Delete dealine months if timeline_state within trial period set instead
            if (this.inputs.timeline_state <= 12) {
                this.inputs.deadline_month = "";
            }

            this.save(this.inputs);
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit("reload-" + this.tableId);
        },

        afterError(res) {
            this.$toastr.e(res.data.message);
        },
        clear() {
            this.inputs = {};
        },

        sentMessage() {
            let data = {};
            data.to = this.atendeeOptions.data;
            data.message = this.inputs.note;
            data.form = this.inputs.id;

            this.axiosPost({
                url: "/admin/app/sent-candidates-messages",
                data: data,
            })
                .then((response) => {
                    if (response.data) {
                        this.$toastr.s(this.$t(response.data.message));
                    } else {
                        this.$toastr.s(this.$t(response.data.message));
                    }
                })
                .finally(() => {});
        },

        /**
         * Load basic data
         */

        afterSuccessFromGetEditData(response) {
            // Handle tags
            if (response.data.tag_id) this.tag = response.data.tag_id;
            if (response.data.tag_id) {
                let added_tags = JSON.parse(response.data.tag_id);

                var _this = this;
                added_tags.forEach(function(entry) {
                    _this.attachTag(parseInt(entry));
                });
            }

            // Handle inputs
            this.inputs = response.data;

            this.inputs.answer_text_1 = "Dokáže MS Excel vytvořit animované grafy?";
            this.inputs.answer_text_2 = "Lze spravovat jednu tabulku na více listech?";
            this.inputs.answer_text_3 = "Funkce MIN slouží k řazení výsledků";

            this.inputs.answer_1 = 0;
            this.inputs.answer_2 = 0;
            this.inputs.answer_3 = 0;

            if (this.inputs.document_type == null || this.inputs.document_type == "sign") {
                this.inputs.document_type = "fill_and_sign"; // backward compatibility
            }

            // Load available jobs
            if (response.data.job_id) {
                let allJobs = JSON.parse(response.data.job_id);
                // Fix to prevent double "" preventing from loading after save                
                if(!Array.isArray(allJobs)){
                    allJobs = [];
                    console.log("job_id is not array");
                }
                let selectedJobs = [];

                var _this = this;
                allJobs.forEach(function(entry) {
                    selectedJobs.push(parseInt(entry));
                });
                this.inputs.job_id = selectedJobs;
            }

            // Load available candidates
            if (response.data.candidate_id) {
                let allCandidates = JSON.parse(response.data.candidate_id);
                // Fix to prevent double "" preventing from loading after save                
                if(!Array.isArray(allCandidates)){
                    allCandidates = [];
                    console.log("candidate_id is not array");
                }
                let selectedCandidates = [];

                allCandidates.forEach(function(entry) {
                    selectedCandidates.push(parseInt(entry));
                });
                this.inputs.candidate_id = selectedCandidates;
            }

            this.inputs.fields = response.data.form_fields;
            this.inputs.body = response.data.body;

            this.preloader = false;
            this.finishedGetData = true;
            this.getAttendees();

            // Add visited candidate to history
            if (history.replaceState && location.href.indexOf("?form") <= 0) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?form=" + this.inputs.id;
                window.history.replaceState({ path: newurl }, "", newurl);
            }
        },
    },
};
</script>
